// extracted by mini-css-extract-plugin
module.exports = {"sectionList":"TeamElementsList-module_sectionList_0ddae","imageLabel":"TeamElementsList-module_imageLabel_0d4da"};